import request from 'superagent';
import CModule from 'cache-service-cache-module';

if (__DEV__) {} else {
	var cacheModule = new CModule({storage: 'local', defaultExpiration: 3600});

	// Check to see if we have the server's timestamp in place.
	cacheModule.get('timestamp', function (err, value) {
		if (!value) {
			value = window.Drupal.settings.abr_general.race_schedule_timestamp;
			cacheModule.set('timestamp', value);
		}
		if (value !== window.Drupal.settings.abr_general.race_schedule_timestamp) {
			console.log('Clearing Cache.');
			cacheModule.flush();
		}
	});

	var superagentCacheConfig = { cacheWhenEmpty: false };
	require('superagent-cache')(request, cacheModule, superagentCacheConfig);
}

export default request;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/common/Request.js
 **/